module.exports = __webpack_public_path__ + "img/icon_60px_45_blue.be46f38c.svg";